module.exports = __webpack_public_path__ + "img/spinner-sector.d1e59a42.svg";